// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nd-1";
export var stateContainer = "_nd-0";